import { render, staticRenderFns } from "./PostsView.vue?vue&type=template&id=dac41090&scoped=true"
import script from "./PostsView.vue?vue&type=script&lang=js"
export * from "./PostsView.vue?vue&type=script&lang=js"
import style0 from "@/styles/views/PostsView/PostsView.less?vue&type=style&index=0&id=dac41090&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dac41090",
  null
  
)

export default component.exports